var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { BackrsIcon } from './BackrsIcon';
import { appColors } from '../assets/appColors';
export var BackrsListItem = function (_a) {
    var title = _a.title, rightIcon = _a.rightIcon, bottomBorder = _a.bottomBorder, onClick = _a.onClick;
    return (_jsxs(Box, { onClick: onClick, sx: __assign(__assign({}, listItemStyle), { borderBottom: bottomBorder ? "1px solid ".concat(appColors.color.taupe1) : 'none' }), children: [_jsx(Typography, { variant: "body1", fontSize: '11pt', lineHeight: '16px', children: title }), _jsx(Box, { sx: iconContainerStyle, children: _jsx(BackrsIcon, { name: rightIcon.name, alt: rightIcon.alt, color: rightIcon.color }) })] }));
};
var listItemStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 1.5,
    px: 1,
    width: '100%',
    backgroundColor: appColors.neutral.white,
    cursor: 'pointer',
};
var iconContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 36,
    ml: 1,
};
